export default {
	name: 'final',
	description: 'Конец раунда',
	title: 'Перерыв',
	minigameType: 'Final',
	generateParams(minigame, state) {
		let curHistory = state.objects.history.filter(elem => elem.type === "task");
		let technicalGameTypes = ["Intro", "Final", "End", "Greeting"];
		const revHistory = curHistory.slice().reverse();
		let roundHistory;
		let res = revHistory.findIndex(elem => elem.minigame.name === "count-rest");
		if(res === -1) {
			roundHistory = revHistory.slice().reverse();
		}
		else {
			roundHistory = revHistory.slice(0, res);
		}
		roundHistory = roundHistory.filter(elem => !technicalGameTypes.includes(elem.minigame.minigameType));
		return { history: state.objects.history, roundHistory: roundHistory, help: state.objects.help };
	},
	isCompleted: () => true,
	score: 0,
};
